module.exports = __webpack_public_path__ + "static/media/overture.b6cd8db4.svg";